import { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { ZoomIn, ZoomOut } from "lucide-react";
import { Modal } from "@/components/Modal";
import { Button } from "@/components/Button";

const loadImage = (src) => new Promise((res, rej) => {
  const img = new Image();
  img.onload = () => res(img);
  img.onerror = rej;
  img.src = src;
});

async function cropToFile(src, area, size = 512) {
  const img = await loadImage(src);
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  canvas.getContext("2d").drawImage(img, area.x, area.y, area.width, area.height, 0, 0, size, size);
  const blob = await new Promise((r) => canvas.toBlob(r, "image/jpeg", 0.9));
  return new File([blob], "avatar.jpg", { type: "image/jpeg" });
}

export function AvatarCropModal({ src, onCancel, onDone, busy }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [area, setArea] = useState(null);
  const onComplete = useCallback((_, px) => setArea(px), []);

  const save = async () => { if (area) onDone(await cropToFile(src, area)); };

  return (
    <Modal open={!!src} onClose={onCancel} title="Crop profile photo" testId="avatar-crop-modal"
      footer={<><Button variant="secondary" full onClick={onCancel} data-testid="avatar-crop-cancel">Cancel</Button><Button full loading={busy} onClick={save} data-testid="avatar-crop-save">Save photo</Button></>}>
      <div className="relative w-full h-72 sm:h-80 rounded-xl overflow-hidden bg-black/60 touch-none" data-testid="avatar-crop-area">
        {src && (
          <Cropper image={src} crop={crop} zoom={zoom} minZoom={1} maxZoom={4} aspect={1} cropShape="round" showGrid={false}
            onCropChange={setCrop} onZoomChange={setZoom} onCropComplete={onComplete} />
        )}
      </div>
      <div className="flex items-center gap-3 mt-4">
        <ZoomOut size={16} className="text-slate-400 shrink-0" />
        <input type="range" min={1} max={4} step={0.01} value={zoom} onChange={(e) => setZoom(Number(e.target.value))}
          className="flex-1 accent-sky-400" aria-label="Zoom" data-testid="avatar-crop-zoom" />
        <ZoomIn size={16} className="text-slate-400 shrink-0" />
      </div>
      <p className="text-xs text-slate-500 mt-2 text-center">Drag to reposition · pinch or scroll to zoom</p>
    </Modal>
  );
}
